import { render, staticRenderFns } from "./TaskTemplateEditForm.vue?vue&type=template&id=78ebf874"
import script from "./TaskTemplateEditForm.vue?vue&type=script&lang=js"
export * from "./TaskTemplateEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports